import { Component, OnInit } from '@angular/core';
import {MultiCrudDataSource} from '../../../../table-datasouces/multi-crud.datasource';
import {toDateString} from '../../../../providers/app-date-adapter';
import {ContentRowField} from '../../../../shared/content-row/content-row.component';
import {CashbackGroup, CashbackGroupMembership} from '../../../../dto/cashbackGroup';
import {ActivatedRoute} from '@angular/router';
import {CashbackGroupsMembershipService} from '../../../../cashback-groups-membership.service';
import {CashbackGroupsService} from '../../../../cashback-groups.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-cashback-groups-detail',
  templateUrl: './cashback-groups-detail.component.html',
  styleUrls: ['./cashback-groups-detail.component.css']
})
export class CashbackGroupsDetailComponent implements OnInit {
  constructor(
    private cashbackGroupMembershipService: CashbackGroupsMembershipService,
    private cashbackGroupService: CashbackGroupsService,
    private route: ActivatedRoute,
    private location: Location,
  ) { }

  ngOnInit(): void {
    const id = parseInt(this.route.snapshot.paramMap.get('id'));

    this.cashbackGroupService.get(id).subscribe(data => {
      this.cashbackGroup = data;
    });

    this.cashbackGroupMembershipService.setCashbackGroup(id);
  }


  dataSource = new MultiCrudDataSource(this.cashbackGroupMembershipService);

  columns = [
    { columnDef: 'token', header: 'Card', cell: (row: CashbackGroupMembership) => row.card?.token,},
    { columnDef: 'customerName', header: 'Name', cell: (row: CashbackGroupMembership) => `${row.card?.customer?.firstName} ${row.card?.customer?.lastName}`,},
    { columnDef: 'product', header: 'Product', cell: (row: CashbackGroupMembership) => row.card?.product?.companyName,},
    { columnDef: 'joinDate', header: 'Joined', cell: (row: CashbackGroupMembership) => `${toDateString(row.joinDate)}`,},
    //{ columnDef: "leaveDate", header: "Left", cell: (row: CashbackGroupMembership) => `${toDateString(row.leaveDate) || ''}`,},

  ] as ContentRowField<CashbackGroupMembership>[];
  getViewLink = (item: CashbackGroupMembership): string => '/customers-overview/' + item.card.customerId.toString();
  cashbackGroup: CashbackGroup;


  returnBack() {
    this.location.back();
  }

}
